const MAX_UPLOADED_FILES_SIZE = 10;
const MAX_FILES = 5;
const ACCEPTED_FILE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'application/pdf',
];

export function checkMaxFiles(
  files: FileList,
  uploadedFiles: File[]
): { isValid: boolean; errorMessage?: string } {
  if (uploadedFiles.length + files.length > MAX_FILES) {
    return {
      isValid: false,
      errorMessage: 'A maximum of 5 files is permitted for submission.',
    };
  }
  return { isValid: true };
}

export function checkMaxUploadSize(
  files: FileList,
  uploadedFilesSize: number
): { isValid: boolean; errorMessage?: string } {
  for (let x = 0; x < files.length; x++) {
    const filesize = files[x].size / (1024 * 1024);

    if (filesize + uploadedFilesSize >= MAX_UPLOADED_FILES_SIZE) {
      return {
        isValid: false,
        errorMessage: `Total size of all uploaded files must be less than or equal to ${MAX_UPLOADED_FILES_SIZE} MB.`,
      };
    }
  }
  return { isValid: true };
}

export function checkFileType(files: FileList): {
  isValid: boolean;
  errorMessage?: string;
} {
  for (let x = 0; x < files.length; x++) {
    if (!ACCEPTED_FILE_TYPES.includes(files[x].type))
      return {
        isValid: false,
        errorMessage:
          'One or more of the uploaded files is an invalid type: only .jpg, .jpeg, .png, and .pdf files are accepted.',
      };
  }
  return { isValid: true };
}
